import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { generarReporteFinanciero } from '../../../services/reporteService';
import styles from './ReportCard.module.css';
import { Calendar, Download, AlertCircle } from 'lucide-react';

export const FinancialReportCard: React.FC = () => {
    const today = new Date();
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1).toISOString().split('T')[0];
    const todayStr = today.toISOString().split('T')[0];

    const [startDate, setStartDate] = useState<string>(firstDayOfMonth);
    const [endDate, setEndDate] = useState<string>(todayStr);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const handleGenerateReport = async () => {
        if (!startDate || !endDate) {
            setError("Por favor, seleccione un rango de fechas válido.");
            return;
        }
        if (new Date(startDate) > new Date(endDate)) {
            setError("La fecha de inicio no puede ser posterior a la fecha de fin.");
            return;
        }
        
        setIsLoading(true);
        setError(null);
        try {
            await generarReporteFinanciero(startDate, endDate);
        } catch (err: any) {
            setError(err.message || "No se pudo generar el reporte.");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <motion.div 
            className={styles.reportCard}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, ease: 'easeOut' }}
        >
            <div className={styles.cardIconWrapper}>
                <Calendar size={28} />
            </div>
            <h3 className={styles.cardTitle}>Reporte Financiero de Ingresos</h3>
            <p className={styles.cardDescription}>
                Seleccione un rango de fechas para generar un reporte en Excel con todos los pagos recibidos en ese período.
            </p>

            <div className={styles.dateRangePicker}>
                <div className={styles.dateInputGroup}>
                    <label htmlFor="start-date">Desde</label>
                    <input 
                        type="date" 
                        id="start-date" 
                        value={startDate} 
                        onChange={(e) => setStartDate(e.target.value)}
                        disabled={isLoading}
                    />
                </div>
                <div className={styles.dateInputGroup}>
                    <label htmlFor="end-date">Hasta</label>
                    <input 
                        type="date" 
                        id="end-date"
                        value={endDate}
                        onChange={(e) => setEndDate(e.target.value)}
                        disabled={isLoading}
                    />
                </div>
            </div>

            {error && 
                <div className={styles.errorMessage}>
                    <AlertCircle size={18} />
                    <span>{error}</span>
                </div>
            }

            <button 
                className={styles.generateButton} 
                onClick={handleGenerateReport} 
                disabled={isLoading}
            >
                {isLoading ? (
                    'Generando...'
                ) : (
                    <>
                        <Download size={18} />
                        <span>Generar y Descargar</span>
                    </>
                )}
            </button>
        </motion.div>
    );
};